module.exports = require("./dist/client");